import { render, staticRenderFns } from "./ShipchartLibrarydetails.vue?vue&type=template&id=57dcd03c&scoped=true&"
import script from "./ShipchartLibrarydetails.vue?vue&type=script&lang=js&"
export * from "./ShipchartLibrarydetails.vue?vue&type=script&lang=js&"
import style0 from "./ShipchartLibrarydetails.vue?vue&type=style&index=0&id=57dcd03c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dcd03c",
  null
  
)

export default component.exports